import moment from 'moment';
import momentTimezone from 'moment-timezone';
import obiqAjax from 'helpers/obiq-ajax';
import lodash from 'lodash';
import uuid from 'uuid';
import Popper from 'popper.js';
import 'blueimp-canvas-to-blob';
import { getGaTracker } from 'helpers/ga';
import { getMomentLocales } from 'utils/locales';

// Moment.js
// gon.user_locale is available on user facing pages loaded through app/controllers/application_controller.rb by the Localized module
const currentLocale = (typeof gon !== 'undefined' && gon.user_locale) || moment.locale();
getMomentLocales().forEach((locale) => {
  if (locale !== 'en') { // "en" is default locale and shouldn't load it manually
    try {
      require(`moment/locale/${locale}.js`); // eslint-disable-line global-require, import/no-dynamic-require
    } catch (e) {
      // Locale file missing from moment — skip silently (e.g. "am" for Amharic)
    }
  }
});
moment.locales().forEach((locale) => {
  momentTimezone.updateLocale(locale, moment.localeData(locale)._config);
});

moment.locale(currentLocale);
momentTimezone.locale(currentLocale);

window.moment = momentTimezone;
window._ = lodash;
window.uuid = uuid;
window.Popper = Popper;
window.getGaTracker = getGaTracker;
window.obiqAjax = obiqAjax;
